<template>
  <div>
    <p>
      Imagine custom building a LEGO Universe model for nothing more than personal pride and satisfaction!
    </p>
    <poll-images id="92fbc139-076b-4977-83fd-da82004e6f4e"></poll-images>
    <poll id="92fbc139-076b-4977-83fd-da82004e6f4e"></poll>
  </div>
</template>
